// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";

import { split } from "@transformers/schema";
import { SchemaForm } from "@components";
import type { EmailNotification } from "@modules/service/reducer/email-notifications/types";

type OwnProps = $Exact<{
  data: ?EmailNotification,
  schema: Object,
  editing?: boolean,
  onChange: (data: Object) => void,
  onSubmit?: (data: Object) => void,
}>;

type OwnState = $Exact<{
  formData: EmailNotification | Object,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export class EmailNotificationsMainForm extends React.Component<Props, OwnState> {
  state = {
    formData: {},
  };

  componentDidMount() {
    if (this.props.data) {
      this.setState({ formData: this.props.data });
    }
  }

  handleChange = (formData: Object) => {
    this.setState({ formData });
    this.props.onChange(formData);
  };

  get data() {
    return { name: this.state.formData.name };
  }

  get schema() {
    return split(this.props.schema, ["name"]);
  }

  get uiSchema() {
    return {
      name: {
        "ui:options": {
          contentclassname: "flex-grow-6",
        },
      },
    };
  }

  render() {
    return (
      <React.Fragment>
        {this.data && this.schema ? (
          <SchemaForm
            className="w-100 pr-1"
            formData={this.data}
            schema={this.schema}
            onChange={this.handleChange}
            uiSchema={this.uiSchema}
            externalSubmit
          />
        ) : null}
      </React.Fragment>
    );
  }
}

export default localize()(EmailNotificationsMainForm);
